import React from 'react';
import { Connection, ConnectionTypes } from '../../../models/Connection';
import { Button, ButtonSize } from '../../../components/Button';
import { ButtonVariant } from '../../../config/colors';

interface ConnectionButtonProps {
  connection: Connection;
  onConnect: (e: React.MouseEvent) => void;
  onChat: (connectionId: string) => void;
  allowPressAwaitingReply: boolean;
}

export const ConnectionButton: React.FC<ConnectionButtonProps> = ({
  connection,
  onConnect,
  onChat,
  allowPressAwaitingReply = false,
}) => {
    const renderPersonConnectButton = (onTap: (e: React.MouseEvent) => void) => {
        return (
            <Button
                variant={ButtonVariant.inverted}
                onClick={onTap}
                size={ButtonSize.small}
            >
              Connect
            </Button>
        );
    }

    const renderPersonConnectedButton = (onTap: (e: React.MouseEvent) => void) => {
        return (
            <Button
                variant={ButtonVariant.primary}
                onClick={onTap}
                size={ButtonSize.small}
            >
              Chat
            </Button>
        );
    }

    const renderPersonPendingButton = () => {
      if(allowPressAwaitingReply) {
        return (
          <button
            className="px-4 py-2 rounded-lg bg-gray-200 text-gray-600"
            onClick={handleConnect}
          >
            Awaiting reply
          </button>
        )
      }
      else {
        return (
            <button
                disabled
                className="px-4 py-2 rounded-lg bg-gray-200 text-gray-600 cursor-not-allowed"
            >
                Awaiting reply
            </button>
        )
      }
    }

    const handleChat = (e: React.MouseEvent) => {
      e.stopPropagation();
      onChat(connection.conversationId ?? '');
    }

    const handleConnect = (e: React.MouseEvent) => {
      e.stopPropagation();
      onConnect(e);
    }

  switch (connection.type) {
    case ConnectionTypes.NOT_ESTABLISHED:
      return renderPersonConnectButton(onConnect);
    case ConnectionTypes.REQUEST_SENT:
      return renderPersonPendingButton();
    case ConnectionTypes.REQUEST_RECEIVED:
    case ConnectionTypes.ESTABLISHED:
      return renderPersonConnectedButton(handleChat);
    case ConnectionTypes.MY_SELF:
    case ConnectionTypes.BLOCKED:
    case ConnectionTypes.EXPIRED:
      return null;
    default:
      return null;
  }
};